import { stringify } from 'query-string';
import { client } from '../client';
import {
  AddTimesheetExcludedUsers,
  ApiTimesheetExcludedUsers,
  RemoveTimesheetExcludedusers,
} from './types';

const baseUrl = '/timesheets/exclude-users';
const get = (): Promise<ApiTimesheetExcludedUsers> =>
  client.get<ApiTimesheetExcludedUsers>(baseUrl);
const add = (
  users: AddTimesheetExcludedUsers,
): Promise<ApiTimesheetExcludedUsers> =>
  client.put(
    `${baseUrl}?${stringify({ userIds: users }, { arrayFormat: 'comma' })}`,
  );
const remove = (users: RemoveTimesheetExcludedusers): Promise<void> =>
  client.delete(
    `${baseUrl}?${stringify({ userIds: users }, { arrayFormat: 'comma' })}`,
  );

export const TimesheetExcludedUsersApi = {
  get,
  add,
  remove,
};
